var FORSURE_DATE_FORMATS = {
  'DD-MM-YYYY': { order: ['DD', 'MM', 'YYYY'], sep: '-' },
  'MM-DD-YYYY': { order: ['MM', 'DD', 'YYYY'], sep: '-' },
  'YYYY-MM-DD': { order: ['YYYY', 'MM', 'DD'], sep: '-' },
  'DD/MM/YYYY': { order: ['DD', 'MM', 'YYYY'], sep: '/' },
  'MM/DD/YYYY': { order: ['MM', 'DD', 'YYYY'], sep: '/' },
  'DD.MM.YYYY': { order: ['DD', 'MM', 'YYYY'], sep: '.' },
};

function forsureDecimalSeparator() {
  var value = window.userPermissions && window.userPermissions.number_decimal_separator;
  return value === 'comma' ? 'comma' : 'dot';
}

function forsureDateFormat() {
  var value = window.userPermissions && window.userPermissions.date_format;
  return FORSURE_DATE_FORMATS[value] ? value : 'DD-MM-YYYY';
}

function forsureFormatNumber(value, options) {
  var number = typeof value === 'number' ? value : Number(String(value).trim());
  if (!isFinite(number)) {
    return value == null ? '' : String(value);
  }
  var locale = forsureDecimalSeparator() === 'comma' ? 'de-DE' : 'en-US';
  var formatOptions = { maximumFractionDigits: 6, useGrouping: true };
  if (options) {
    Object.keys(options).forEach(function(key) {
      formatOptions[key] = options[key];
    });
  }
  return new Intl.NumberFormat(locale, formatOptions).format(number);
}

function forsureFormatDate(value, includeTime) {
  if (value == null || value === '') {
    return '';
  }
  var date = value instanceof Date ? value : new Date(value);
  if (isNaN(date.getTime())) {
    return String(value);
  }
  var spec = FORSURE_DATE_FORMATS[forsureDateFormat()];
  var parts = {
    DD: String(date.getDate()).padStart(2, '0'),
    MM: String(date.getMonth() + 1).padStart(2, '0'),
    YYYY: String(date.getFullYear()),
  };
  var text = spec.order.map(function(part) { return parts[part]; }).join(spec.sep);
  var hasClockTime = date.getHours() !== 0 || date.getMinutes() !== 0 || date.getSeconds() !== 0;
  if (includeTime === true || (includeTime !== false && hasClockTime)) {
    text += ' ' + String(date.getHours()).padStart(2, '0') + ':' + String(date.getMinutes()).padStart(2, '0');
  }
  return text;
}

function forsureFormatChartLabel(label) {
  if (typeof label !== 'string' || !/^\d{4}-\d{2}-\d{2}(?:[T ]\d{2}:\d{2}(?::\d{2})?)?/.test(label)) {
    return label == null ? '' : String(label);
  }
  return forsureFormatDate(label);
}
